import React from 'react';
import ReactDOM from 'react-dom';

import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import NoResult from '../../components/general/NoResult';
import TimeAgo from 'react-timeago'
import General from '../../helpers/General.js';
import GeneralHelper from '../../modules/General';
import Gravatar from 'react-gravatar';
import moment from 'moment';

import {setOpenChat,resetFilterOption,setFilterOption,removeFilterOption} from '../../actions/Chat.js';

class ChatOverview extends React.Component {
	constructor(props) {
		super(props);

		this.openChat = this.openChat.bind(this);
		this.renderUnread = this.renderUnread.bind(this);
	}

	openChat(uid) {
		this.props.setOpenChat(uid,this.props.auth.user.id);
		this.props.router.push(GeneralHelper.Link('/chat/'+this.props.auth.user.id+'/'+uid));
	}

	setFilterOption(option,text) {

		if(option === false) {
			this.props.resetFilterOption();
		}else{
			let value = {'text':text,'key':option};
			let exist = false;

			for(let i in this.props.chat.filterOptions) {
				if(this.props.chat.filterOptions[i].key == option) {
					exist = true;
				}
			}

			if(!exist) {
				this.props.setFilterOption(value);
			}
		}
	}

	initFilter() {
		if(typeof localStorage.chatFilter === 'undefined') {
			localStorage.chatFilter = JSON.stringify([]);
		}else{
			return JSON.parse(localStorage.chatFilter);
		}

		return [];
	}

	componentDidMount() {
		this.initFilter().map(item => {
			this.props.setFilterOption(item);
		});
	}

	removeFilterOption(option) {
		this.props.chat.filterOptions.map((item,i) => {
			if(item.key == option) {
				this.props.removeFilterOption(i);
			}
		});
	}

	componentDidUpdate() {
		localStorage.chatFilter = JSON.stringify(this.props.chat.filterOptions);
	}

	filterOptions(option) {
		return (
			<li key={`${option.key}-filter`}><a href="javascript:void(0)" onClick={(e) => {e.stopPropagation(); this.removeFilterOption(option.key)}} className="btn btn-outline btn-default">{option.text} <i className="icon wb-close-mini" aria-hidden="true"></i></a></li>
		)
	}

	shouldIncludeInFilter(visitor) {
		if(this.props.chat.filterOptions.length == 0) {
			return true;
		}

		let include = true;

		for(let i in this.props.chat.filterOptions) {
			let option = this.props.chat.filterOptions[i];
			switch(option.key) {
				case 'open_conversations':
					if(visitor.started != true) {
						include = false;
					}
				break;

				case 'anonymous_visitors':
					if(visitor.email != '') {
						include = false;
					}
				break;

				case 'identified_visitors':
					if(visitor.email == '') {
						include = false;
					}
				break;

				case 'has_products_in_cart':
					if(visitor.cart_items == 0) {
						include = false;
					}
				break;

				case 'no_products_in_cart':
					if(visitor.cart_items > 0) {
						include = false;
					}
				break;
			}
		}

		return include;


	}

    getConversationStatus = (visitor) => {
		if(visitor.started == 1 && visitor.assignee_id == 0) {
			return 'Open and not assigned';
		}

		if(visitor.started == 1 && visitor.assignee_id > 0) {
			return 'Open and assigned';
		}

		return '-';
	}

	renderTableItem(visitor) {
		let total = 0;

		if(visitor.started != 1) {
            if(visitor.online != 1) {
                return false;
            }
		}


		if(!this.shouldIncludeInFilter(visitor)) {
			return false;
		}

		return (
			<tr key={visitor.uid} onClick={() => this.openChat(visitor.uid)}>
	            <td>{(visitor.email == false ? 'Unknown':visitor.email)}</td>
	            <td>
					{this.getConversationStatus(visitor)}
				</td>
				<td>{visitor.unreadMessages > 0 ? <span className="tag tag-danger">{visitor.unreadMessages}</span>:0}</td>
	            <td>{moment(visitor.last_seen).fromNow()}</td>
	            <td>{visitor.cart_items}</td>
	            <td>{visitor.cart_total}</td>
	            <td>{visitor.title}</td>
	            <td>{(visitor.referrer == false ? 'Direct':visitor.referrer)}</td>
	        </tr>
		);
	}

	renderUnread() {
		let visitors = [];

		{Object.keys(this.props.chat.visitors).map((i) => {
			if(this.props.chat.visitors[i].unreadMessages == 0) {
				return true;
			}
			visitors.push(
				<div key={i} onClick={(e) => {e.stopPropagation(); this.openChat(this.props.chat.visitors[i].uid)}} className="card col-sm-4 col-md-3 col-p-t-10 m-t-20 m-r-20" style={{cursor:'pointer',backgroundColor: '#f3f7fa',border:'1px solid #eee'}}>
					<div className="ribbon ribbon-badge ribbon-danger">
                <span className="ribbon-inner">
                	<i className="icon wb-chat"></i> <strong>{this.props.chat.visitors[i].unreadMessages}</strong>
                </span>
              </div>
                  <Gravatar email={this.props.chat.visitors[i].email ? this.props.chat.visitors[i].email : 'nobody'} size={100} rating="pg" default="identicon" className="avatar avatar-100 bg-white m-b-10 m-xs-0 img-bordered" />
                  <div className="card-block">
                    <h4 className="card-title">{this.props.chat.visitors[i].name ? this.props.chat.visitors[i].name : 'Unknown'}</h4>
                    <p className="card-text">{this.props.chat.visitors[i].email ? this.props.chat.visitors[i].email : 'Unknown'}</p>
                    <p className="card-text">
                      <small className="text-muted">Last active {moment(this.props.chat.visitors[i].last_seen).fromNow()}</small>
                    </p>
                  </div>
                </div>
			)
        })}

		if(visitors.length == 0) {
			return;
		}

		return (
			<div className="col-sm-12 masonry-item p-0" >
          <div className="card card-shadow avatar-group">
            <div className="card-header bg-white text-xs-center p-30">



<div className="card-deck-wrapper">
              <div className="card-deck">


              {visitors}




              </div>
            </div>





            </div>

          </div>
        </div>
		);
	}

	renderVisitors() {
		let data = [];
		let result = true;

		{Object.keys(this.props.chat.visitors).map((i) => {
			let item = this.renderTableItem(this.props.chat.visitors[i]);
			if(item !== false) {
				data.push(item);
			}
        })}

        if(data.length == 0) {
        	if(this.props.chat.filterOptions.length == 0) {
        		return <NoResult
					header="No visitors"
					body="You currently have no visitors."
				/>
        	}else{
        		return <NoResult
					header="No matches"
					body="Your current filter didn't return any matches."
				/>
        	}
        }

		return (
			<table>

			    <thead>
			        <tr>
			            <th>E-mail</th>
			            <th>Status</th>
						<th>Unread Messages</th>
			            <th>Last activity</th>
			            <th>Products in cart</th>
			            <th>Total</th>
			            <th>Current page</th>
			            <th>Referrer</th>
			        </tr>
			    </thead>

			    <tbody>
			        {data}
			    </tbody>

			</table>
		)
	}

	render() {
		return (
			<div className="full-height">
				<div className="options pull-right">
					<ul className="nav nav-tabs nav-tabs-solid">
					<li>
							<div className="dropdown">
								<button type="button" className="btn btn-default btn-outline dropdown-toggle" data-toggle="dropdown" aria-expanded="false">
									Filter list
									<span className="caret"></span>
								</button>
								<div className="dropdown-menu dropdown-menu-right" role="menu">
									<a className="dropdown-item" onClick={() => this.setFilterOption('open_conversations','Open conversations')} href="javascript:void(0)" role="menuitem">Open conversations</a>
									<a className="dropdown-item" onClick={() => this.setFilterOption('anonymous_visitors','Anonymous visitors')} href="javascript:void(0)" role="menuitem">Anonymous visitors</a>
									<a className="dropdown-item" onClick={() => this.setFilterOption('identified_visitors','Identified visitors')} href="javascript:void(0)" role="menuitem">Identified visitors</a>
									<a className="dropdown-item" onClick={() => this.setFilterOption('has_products_in_cart','Has products in cart')} href="javascript:void(0)" role="menuitem">Has products in cart</a>
									<a className="dropdown-item" onClick={() => this.setFilterOption('no_products_in_cart','Don\'t have products in cart')} href="javascript:void(0)" role="menuitem">Don't have products in cart</a>
								</div>
							</div>
						</li>
						<li>
							<button type="button" onClick={() => this.setFilterOption(false,false)} className="btn btn-default btn-outline">
								Clear filter
							</button>
						</li>
						<li className="filter-options">
							<ul>
								{this.props.chat.filterOptions.map((option) => {
									return this.filterOptions(option);
								})}
							</ul>
						</li>




					</ul>
				</div>
				<div id="overview" className="col-sm-12 ">
				{this.renderUnread()}
				{this.renderVisitors()}
				<br /><br />
				</div>
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		chat:state.chat,
		auth:state.auth
	}
}

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({setOpenChat,resetFilterOption,setFilterOption,removeFilterOption},dispatch)
}

export default connect(mapStateToProps,mapDispatchToProps)(ChatOverview)



// WEBPACK FOOTER //
// ./containers/chat/ChatOverview.js